import clsx from 'clsx';
import React from 'react';
import { prepareData } from 'utils/googleData';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PricingCTA } from 'components/PricingCTA';
import { SignupCTA } from 'components/SignupCTA';

export const CTAArrayWrapper = ({ children, className = '' }) => {
  return <div className={`flex flex-row items-center gap-4 ${className}`}>{children}</div>
}

function ensurePropsFormat(props) {
  if (!props) {
    return null;
  }
  const hasAllKey = Object.keys(props).some(key => key.startsWith("all"));
  if (!hasAllKey) {
    return { allProps: props };
  }
  return props;
}

export default function Hero2(props) {
  const {
    enable,
    name,
    title,
    subtitle,
    title2,
    subtitle2,
    gatsbyImage,
    signupCTA,
    bookameetingCTA
  } = prepareData({ props })
  // i want to check if enable is a boolean

  if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }

  return (
    <section className="relative bg-[#0B1C39] overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B1C39] to-[#1B3154]"></div>
      
      <div className="container relative z-10 mx-auto px-4 pt-8 pb-16">
        {/* Company name */}
        <div className="mb-4">
          <h3 className="text-xl text-white/90">{name}</h3>
        </div>

        <div className="flex flex-col lg:flex-row items-start justify-between relative">
          {/* Left section */}
          <div className="text-white lg:max-w-[40%] mb-12 lg:mb-0">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">{title}</h1>
            <p className="text-lg lg:text-xl mb-8 text-white/80">{subtitle}</p>
            <CTAArrayWrapper>
              <PricingCTA {...ensurePropsFormat(bookameetingCTA)} />
              <SignupCTA {...ensurePropsFormat(signupCTA)} />
            </CTAArrayWrapper>
          </div>

          {/* Center image with glow effect */}
          <div className="lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:top-20 z-10">
            <div className="relative">
              {/* Glow effects */}
              <div className="absolute -inset-4 bg-[#4BB3FD]/20 rounded-full blur-2xl"></div>
              <div className="absolute -inset-8 bg-[#4BB3FD]/10 rounded-full blur-3xl"></div>
              <div className="absolute -inset-12 bg-[#4BB3FD]/5 rounded-full blur-3xl"></div>
              
              {/* Robot image */}
              {gatsbyImage && (
                <GatsbyImage
                  image={gatsbyImage}
                  alt="AI Robot"
                  className="w-[300px] lg:w-[400px] h-auto relative z-10"
                />
              )}
            </div>
          </div>

          {/* Right section */}
          <div className="text-white lg:max-w-[35%] mt-12 lg:mt-0 lg:pt-64">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">{title2}</h2>
            <p className="text-lg lg:text-xl text-white/80">{subtitle2}</p>
          </div>
        </div>
      </div>

      {/* Bottom gradient overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#0B1C39] to-transparent"></div>
    </section>
  );
}
